module.exports = __webpack_public_path__ + "img/selectImg.cd3cff7.svg";